module.exports = __webpack_public_path__ + "static/img4-98f86b3301365c971fcc0729d43152ae.jpg";